import $ from 'jquery';

const $document = $(document);
const $shareButton = $('.share__button');
let lastCopied = false;

$(function () {
    if ($shareButton.length > 0) {
        window.addEventListener('copy', () => {
            lastCopied = window.getSelection().toString();
            updateButtons();
        });
        $shareButton.each(function () {
            share($(this));
        });
    }
});

const share = element => {
    const lang = element.closest('.share').data('lang');

    if (navigator.clipboard) {
        if (lang === 'cs') {
            element.attr('title', 'Zkopírovat odkaz do schránky');
        } else {
            element.attr('title', 'Copy link to clipboard');
        }
    } else {
        element.css('display', 'none');
    }

    element.on('click', function () {
        const url = element.data('url');

        if (navigator.clipboard) {
            navigator.clipboard
                .writeText(url)
                .then(() => {
                    lastCopied = url;

                    const event = new CustomEvent('alert', {
                        detail: {
                            type: 'alert--success',
                            msg: 'Odkaz stránky byl zkopírován do schránky.',
                            msgEn: 'The page link has been copied to clipboard.',
                        },
                    });
                    document.dispatchEvent(event);
                })
                .catch(console.error);
            element.addClass('active');
        }
    });
};

const updateButtons = () => {
    const $activeButton = $('.share__button.active');

    if ($activeButton !== undefined) {
        console.log(lastCopied);
        console.log($activeButton.data('url'));
        if (lastCopied !== $activeButton.data('url')) {
            $activeButton.removeClass('active');
        }
    }
};

$document.on('click', '.post-card__share, .header__referal', function () {
    const $thisEl = $(this);
    const url = $thisEl.data('url');
    const heading = $thisEl.attr('title');

    $document.find('.share-modal__heading').html(heading);
    $document.find('.share__input').val(url);
    $document.find('.share__button').data('url', url);

    updateButtons();
});
